import React from 'react';
import { useRouterProps } from '../hooks/useRouterProps';

/**
 * Public route guard - no restrictions, always renders
 * Use this for public pages like /forms, /about
 */
const PublicRoute = ({ children, render, ...props }) => {
    const routerProps = useRouterProps();

    return render ? render({ ...props, ...routerProps }) : children;
};

export default PublicRoute;
